import { useAbility } from '@cast/shared-ability-data-access';

export const useIsCustomMetricsEnabled = () => {
  return useAbility().can('view', 'ClusterWorkloadCustomMetrics');
};
